export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/14ed8dc335eec8ccd043173219a4387f.svg";